export const passwordCheckElements = () => ({
    passwordOne: document.querySelector('input#password'),
    passwordOneInfo: document.querySelector('input#password').parentElement.nextSibling
});
